module.exports = __webpack_public_path__ + "img/ico16.1963da89.svg";